import { api, tokenStore } from "./client";
import {
  TokenPair,
  MeResponse,
  type LoginRequest,
  type ChangePasswordRequest,
} from "./schemas";

export async function login(req: LoginRequest): Promise<TokenPair> {
  const res = await api.post("/api/auth/login", req);
  const parsed = TokenPair.parse(res.data);
  tokenStore.set(parsed.access_token, parsed.refresh_token);
  return parsed;
}

export async function refresh(refreshToken: string): Promise<TokenPair> {
  const res = await api.post("/api/auth/refresh", { refresh_token: refreshToken });
  const parsed = TokenPair.parse(res.data);
  tokenStore.set(parsed.access_token, parsed.refresh_token);
  return parsed;
}

export async function logout(): Promise<void> {
  const rt = tokenStore.refresh;
  try {
    await api.post("/api/auth/logout", rt ? { refresh_token: rt } : {});
  } catch {
    // Best-effort. Even if the server is unreachable we still clear local state.
  } finally {
    tokenStore.clear();
  }
}

export async function fetchMe(): Promise<MeResponse> {
  const res = await api.get("/api/auth/me");
  return MeResponse.parse(res.data);
}

export async function changePassword(req: ChangePasswordRequest): Promise<void> {
  await api.post("/api/auth/change-password", req);
}
